import React from 'react';
import { PathwayExportBundle } from '../../types/pathway';
import { PathwayDocument } from './PathwayDocument';
interface BundleDocumentProps {
  bundle: PathwayExportBundle;
  coverOnly?: boolean;
}
export function BundleDocument({
  bundle,
  coverOnly = false
}: BundleDocumentProps) {
  const first = bundle.pathways[0];
  if (!first) return null;
  return <div className="flex flex-col items-center gap-8" data-id="element-1526" data-mp="yio3cs67k6cw">
      <PathwayDocument pathwayName={bundle.name} company={first.company} cohort={first.cohort} audience={first.audience} items={first.items} fields={bundle.fields} coverOnly data-id="element-1527" data-mp="aw7xxx9eth6y" />
      {!coverOnly && bundle.pathways.map(pathway => <section key={pathway.id} className="flex flex-col items-center gap-3" data-id="element-1528" data-mp="kmaqxxgj6v5a">
          <div className="w-[816px] text-left text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-1529" data-mp="fspysm1mcve0">Pathway {pathway.order} of {bundle.pathways.length}</div>
          <PathwayDocument pathwayName={pathway.pathwayName} company={pathway.company} cohort={pathway.cohort} audience={pathway.audience} items={pathway.items} fields={bundle.fields} data-id="element-1530" data-mp="3jbja0s6xd850" />
        </section>)}
    </div>;
}